import React, { useEffect } from 'react';

// Import wine menu images
import vinos1 from '../images/vinos/vino1.webp';
import vinos2 from '../images/vinos/vino2.webp';
import vinos3 from '../images/vinos/vino3.webp';
import vinos4 from '../images/vinos/vino4.webp';
import vinos5 from '../images/vinos/vino5.webp';
import vinos6 from '../images/vinos/vino6.webp';
import vinos7 from '../images/vinos/vino7.webp';

// Import wine PDF
import vinoPdf from '../pdfs/Carta_Vinos.pdf';

export default function Vinos() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const wineImages = [vinos1, vinos2, vinos3, vinos4, vinos5, vinos6, vinos7];

    const handleDownload = () => {
        window.open(vinoPdf, '_blank');
    };

    return (
        <div className="bg-[#1b1b1b] font-ubuntu">
            <div className="container mx-auto px-4 py-8">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-white font-montserrat text-3xl font-bold uppercase">
                        Vinos
                    </h2>
                    <button
                        onClick={handleDownload}
                        className="px-4 py-2 bg-white text-black font-montserrat text-sm uppercase hover:scale-110 transition-transform duration-300"
                    >
                        DESCARGAR PDF
                    </button>
                </div>
            </div>

            <div className="w-full">
                <div className="flex flex-col items-center">
                    <div className="w-full max-w-3xl mx-auto">
                        {wineImages.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Carta de vinos página ${index + 1}`}
                                className="w-full h-auto block"
                                style={{ marginTop: '-1px', marginBottom: '-1px' }}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <div className="h-16"></div>
        </div>
    );
}